import styled from '@themes/theme'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'
import { ButtonStyles } from '@styles/button.style'
import { TxtLimit } from '@styles/base.style'

export const SportTalkPreviewBtn = styled.button`
  ${ButtonStyles};
  width: calc(100% - 28px);
  //height: 59px;
  background: ${props => props.theme.color.subColor2};
  display: flex;
  margin: 6px auto 10px;
  padding: 10px 14px;
  border-radius: 14px;
  .profile-img-wrap {
    ${ProfileImgWrapStyle};
    width: 24px;
    height: 24px;
    min-width: 24px;
    transform: translateY(3px);
    overflow: visible;
    .profile-img {
      border-radius: 50%;
      height: 100%;
    }
    &.blocked {
      opacity: .3;
    }
  }
  .sport-talk-contents {
    &-wrap {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: calc(100% - 24px - 8px);
      margin-left: 8px;
      .nick {
        display: block;
        width: 100%;
        text-align: left;
        margin-bottom: 2px;
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.bold};
        color: ${props => props.theme.color.themeTxt};
        line-height: ${props => props.theme.font.largeNum};
      }
      &.blocked {
        .nick {
          color: ${props => props.theme.color.btn};
        }
      }
    }
    width: 100%;
    ${TxtLimit};
    text-align: left;
    font-size: ${props => props.theme.font.medium};
    font-weight: ${props => props.theme.fontW.regular};
    color: ${props => props.theme.color.darkTxt};
    line-height: ${props => props.theme.font.largeNum};
    &.blocked {
      color: ${props => props.theme.color.disableBg};
    }
    // SportTalkIssuePreview 컴포넌트 스타일
    &.info {
      margin: 8px 0 0 6px;
    } 
  }
  // SportTalkIssuePreview 컴포넌트 스타일
  .preview-img {
    width: 60px;
    min-width: 60px;
    height: 34px;
    border-radius: 8px !important;
    overflow: hidden !important;
    object-fit: cover;
    &.iframe {
      position: relative;
      .rsme-embed {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: scale(0.25) translate(-200%, -200%);
        border-radius: 32px !important;
        pointer-events: none;
        .youtube-iframe {
          height: 100%;
          aspect-ratio: 60/34;
          > iframe {
            height: 100%;
          }
        }
      }
    }
  }
  // 경기결과 페이지 내 스포츠톡 미리보기 스타일
  &.is-gray {
    background: #E1E4EB;
    .profile-img-wrap {
      &.blocked {
        opacity: .4;
      }
    }
    .sport-talk-contents {
      &-wrap {
        .nick {
          color: ${props => props.theme.color.modalTxt};
        }
        &.blocked {
          .nick {
            color: ${props => props.theme.color.disableTxt};
          }
        }
      }
      color: ${props => props.theme.color.subColor};
      &.blocked {
        color: ${props => props.theme.color.disableTxt};
      }
    }
  }
    
`